import { Component, OnInit } from '@angular/core';
import { UXControllerService } from './service/controller/ux-controller.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {
  title = 'CosyJS';

  constructor(private router: Router){
  }
  
  ngOnInit() {
    this.router.navigate(['/server']);  
  }
  
}
